import axios from 'axios';

/**
 * The Laravel API. Served by Laravel (production), the page tells us its URL
 * in window.__DARAF__.api; on the CRA dev server REACT_APP_API_URL is used.
 */
export const API_URL = (typeof window !== 'undefined' && window.__DARAF__?.api) || process.env.REACT_APP_API_URL || '/api/v1';

/** The site language comes from the URL: /ar/... is Arabic, everything else English. */
export const LOCALE = typeof window !== 'undefined' && window.location.pathname.split('/')[1] === 'ar' ? 'ar' : 'en';
export const DEFAULT_LOCALE = 'en';
export const LOCALES = ['en', 'ar'];

const api = axios.create({
    baseURL: API_URL,
    headers: { Accept: 'application/json', 'Accept-Language': LOCALE },
    params: { lang: LOCALE },
});

// GET responses are the same until the dashboard changes something: keep them for the visit.
const cache = new Map();

/** GET an API path and return its `data` (cached per path for this visit). */
export function fetchData(path) {
    if (!cache.has(path)) {
        cache.set(
            path,
            api.get(path).then((response) => response.data.data).catch((error) => {
                cache.delete(path);
                throw error;
            }),
        );
    }

    return cache.get(path);
}

/** POST a site form (JSON or FormData) and return the API envelope. */
export function submitForm(path, body) {
    return api.post(path, body).then((response) => response.data);
}

export default api;
